var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M33 41H16V26.293l6.877-19.252c.279-.78 1.232-1.217 2.128-.974.534.145.952.51 1.118.974L33 26.293V41zm-6.495-29.779h-4.011L17.5 26.405l-.001.019h14l.001-.021-4.995-15.182z", fill: "currentColor", fillRule: "nonzero", stroke: "none", strokeWidth: 1 })));
});
